<template>
  <span>
    <img
      :src="`static/images/icons/${icon}.svg`"
      v-bind="$attrs"
      v-on="$listeners"
      :class="imgClass"
    />
    <slot></slot>
  </span>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['icon', 'imgClass'],
};
</script>
